<template>
  <div class="home">

    <section  class="py-7 py-md-9">
      <div class="container">
        <div class="row">
          <div class="col-md-4 order-md-3">
            <!-- Media -->
            <div class="media-decoration media-decoration-1 mb-5 mb-md-0">
              <!-- Image -->
              <img
                class="media-decoration-img img-fluid"
                src="@/assets/iconos/cancer-mama/icon-2.png"
                alt="..."
              />
            </div>
          </div>
          <div class="col-md-5 order-md-1 align-self-center mx-auto">
            <!-- Heading -->
            <h2 class="mb-2">Antecedentes</h2>

            <!-- Text -->
            <p class="mb-0">
            El cáncer de mama es la primera causa de muerte en mujeres a nivel nacional y Nuevo León no escapa a ello; lo más 
            lamentable es que muchas de ellas no sabían que padecían la enfermedad hasta que fue demasiado tarde para iniciar 
            un tratamiento oportuno y poder curarse.
            <br>
            Al 2021, la tasa de mortalidad en Nuevo León se ubicó en 28.1 defunciones por 100 mil mujeres  de 25 años y más. 
            Por ello, es importante reforzar las acciones de detección oportuna.  
          </p>
          </div>
        </div>
      </div>
    </section>





    <section id="preg-1" class="pt-7 pt-md-9">
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <!-- Media -->
            <div class="media-decoration media-decoration-1 mb-5 mb-md-0">
              <!-- Image -->
              <img
                class="media-decoration-img img-fluid"
                src="@/assets/iconos/cancer-mama/icon-14.png"
                alt="..."
              />
            </div>
          </div>
          <div class="col-md-5 align-self-center mx-auto">
            <!-- Heading -->
            <h2 class="mb-2">{{ datos1.preg }}</h2>

            <!-- Text -->
            <p class="mb-0">{{ datos1.resp }}</p>
          </div>
        </div>
      </div>
    </section>

    <section id="preg-2" class="py-7 py-md-9">
      <div class="container">
        <div class="row">
          <div class="col-md-4 order-md-3">
            <!-- Media -->
            <div class="media-decoration media-decoration-1 mb-5 mb-md-0">
              <!-- Image -->
              <img
                class="media-decoration-img img-fluid"
                src="@/assets/iconos/cancer-mama/icon-10.png"
                alt="..."
              />
            </div>
          </div>
          <div class="col-md-5 order-md-1 align-self-center mx-auto">
            <!-- Heading -->
            <h2 class="mb-2">{{ datos2.preg }}</h2>

            <!-- Text -->
            <p class="mb-0">{{ datos2.resp }}</p>
          </div>
        </div>
      </div>
    </section>

    <section id="preg-3" class="pt-7 pt-md-9">
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <!-- Media -->
            <div class="media-decoration media-decoration-1 mb-5 mb-md-0">
              <!-- Image -->
              <img
                class="media-decoration-img img-fluid"
                src="@/assets/iconos/cancer-mama/icon-9.png"
                alt="..."
              />
            </div>
          </div>
          <div class="col-md-5 align-self-center mx-auto">
            <h2 class="mb-2">{{ datos3.preg }}</h2>
            <!-- Text -->
            <p class="mb-0">{{ datos3.resp }}</p>
            <!-- List -->
            <ul style="margin-top: 16px">
              <li
                style="margin-top: 8px"
                v-for="(textToPlace, index) in datos3.list"
                v-bind:key="index"
              >
                {{ textToPlace.text }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    

    <section id="preg-5">
      <div class="jumbotron d-flex">
        <div class="container">
          <div class="row text-center">
            <img
              class="media-decoration-img img-fluid"
              src="@/assets/iconos/cancer-mama/icon-8.png"
              alt="..."
              style="margin-left: auto; margin-right: auto"
            />
            <h2 class="mb-2">{{ datos5.title }}</h2>
            <p class="mb-0">{{ datos5.msg }}</p>
          </div>
          <div class="row" style="margin-top: 16px">
            <ul v-for="(datos, index) in datos5.syntoms" v-bind:key="index">
              <li>{{ datos.text }}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section id="preg-6" class="py-7 py-md-9">
      <div class="container">
        <div class="row">
          <div class="col-md-4 order-md-3">
            <!-- Media -->
            <div class="media-decoration media-decoration-1 mb-5 mb-md-0">
              <!-- Image -->
              <img
                class="media-decoration-img img-fluid"
                src="@/assets/iconos/cancer-mama/icon-7.png"
                alt="..."
              />
            </div>
          </div>
          <div class="col-md-5 order-md-1 align-self-center mx-auto">
            <h2 class="mb-2">{{ datos6.preg }}</h2>

            <!-- Text -->
            <p class="mb-0">{{ datos6.resp }}</p>
          </div>
        </div>
      </div>
    </section>

    <section id="preg-4" class="py-7 py-md-9">
      <div class="container">
        <div class="row">
          <div class="col-md-4 order-md-3">
            <!-- Media -->
            <div class="media-decoration media-decoration-1 mb-5 mb-md-0">
              <!-- Image -->
              <img
                class="media-decoration-img img-fluid"
                src="@/assets/iconos/cancer-mama/icon-6.png"
                alt="..."
              />
            </div>
          </div>
          <div class="col-md-5 order-md-1 align-self-center mx-auto">
            <h2 class="mb-2">{{ datos4.preg }}</h2>

            <!-- Text -->
            <p class="mb-0">{{ datos4.resp }}</p>
          </div>
        </div>
      </div>
    </section>



    <section id="preg-7" class="jumbotron d-flex align-items-center">
      <div class="container">
        <div class="row">
          <h2 class="text-center">{{ datos7.preg }}</h2>

          <!-- Text -->
          <ul>
            <li v-for="(links, index) in datos7.resp" v-bind:key="index">
              <a v-bind:href="'' + links.url">{{ links.title }}</a>
            </li>
          </ul>

          <ul>
            <p>Bibliografía</p>
            <li
              v-for="(biblio, index) in datos7.bibliografia"
              v-bind:key="index"
            >
              <a v-bind:href="'' + biblio.url">{{ biblio.title }}</a>
            </li>
          </ul>
        </div>
      </div>
    </section>


    
  </div>
</template>


<style>
#middle-contact {
  min-height: 20vh;
  padding: 36px;
  background-color: #e0e0e0; /* Material Gray 300 */
}

#fuentes {
  margin-top: 36;
}

#preg-7 {
  background-color: #f5f5f5; /* Material Grey 100 */
  padding: 36px;
}

#preg-7 .container ul {
  margin-top: 32px;
  list-style-type: none;
}

#preg-5 {
  padding: 36px;
  margin: 36px;
}

.media-decoration-img {
  max-width: 300px;
}

.home .container .row {
  max-width: 90%;
  margin-left: auto;
  margin-right: auto;
}
</style>


<script>
// Importamos JQuery
const $ = require("jquery");
// Lo declaramos globalmente
window.$ = $;

$(document).ready(function () {
  //console.info("pageReady");

  /**
   * Listen to scroll to change header opacity class
   */
  function checkScroll() {
    var startY = $(".navbar").height() * 2; //The point where the navbar changes in px

    if ($(window).scrollTop() > startY) {
      $(".navbar").addClass("scrolled");
    } else {
      $(".navbar").removeClass("scrolled");
    }
  }

  if ($(".navbar").length > 0) {
    $(window).on("scroll load resize", function () {
      checkScroll();
    });
  }
});

// @ is an alias to /src
//import Index from '@/components/Index.vue'

export default {
  name: "Home",
  components: {
    //Index
  },
  methods: {
    ShowAlert(title, message, icon) {
      this.$swal(title, message, icon);
    },

    ShowMore(title, text) {
      // type: 1 Hematologicos, typ:2 Tumorales

      this.$swal({
        title: title,
        html: text,
        icon: "info",
      });
    },
  },
  data() {
    return {
      datos1: {
        preg: "¿Qué es el cáncer de mama?",
        resp: `El cáncer de mama es una enfermedad que se origina en el tejido mamario, a partir 
                del crecimiento anormal de una sola célula o de un grupo de ellas, que poseen la 
                capacidad de invadir tanto los órganos vecinos, como los ganglios linfáticos u órganos 
                alejados como el pulmón, hígado, cerebro, etc.
              `,
      },
      datos2: {
        preg: "Causas del cáncer de mama",
        resp: `No existe una causa específica, se considera que se origina por múltiples factores como el estilo de vida de las personas, mutaciones genéticas y factores o condiciones ambientales que propician su desarrollo.`,
      },
      datos3: {
        preg: "Medidas de diagnóstico oportuno",
        resp: `Brindar atención médica oportuna en el primer nivel de atención es una estrategia crucial para la detección temprana del cáncer y para ello existen una serie de estudios de tamizaje que pueden ayudar cuando aún no se presentan síntomas:`,
        list: [
          {
            text: `Autoexploración mamaria: Se realiza una vez al mes a partir del inicio de la menstruación, entre el día  7 y 10 del periodo, o si ya no menstrúa, elegir 1 día fijo al mes.`,
          },
          {
            text: `Autoexploración clínica: Se realiza a partir de los 25 años en la unidad de salud por personal capacitado. Se recomienda practicarla una vez al año.`,
          },
          {
            text: `Mamografía: Se realiza anualmente a partir de los 40 años.`,
          },
        ],
      },

      datos4: {
        preg: "Tratamiento",
        resp: `Cuando el cáncer se detecta en etapas tempranas, puede ser curable mediante cirugías y medicamentos como quimioterapias, terapia dirigida,
               terapia hormonal, inmunoterapia, radiación, entre otras.

              El tipo de tratamiento depende de cada caso en particular y es multidisciplinario para aminorar los efectos que pudiera ocasionar la propia 
              enfermedad o el tratamiento. 
              `,
      },
      datos5: {
        title: "Signos y sintomas",
        msg: "Algunos de los signos y síntomas que se pueden presentar son:",
        syntoms: [
          { text: "Masas palpables (bolitas)" },
          { text: "Lesiones palpables en axila" },
          { text: "Secreción por el pezón" },
          { text: "Asimetría mamaria" },
          { text: "Retracción del pezón" },
          { text: "Piel de naranja en los senos" },
          { text: "Lesiones en la piel de los senos" },
          { text: "Alteraciones en los resultados de mamografía de tamizaje" },
        ],
      },
      datos6: {
        preg: "¿Qué hacer si se sospecha de algún síntoma de cáncer de mama?",
        resp: "Si presentas alguno de estos signos o síntomas, no lo pienses y acude a la Unidad de Salud más cercana para realizar una valoración completa y determinar el tratamiento a seguir.",
      },
      datos7: {
        preg: "¿En dónde puedo leer más información confiable?",
        resp: [
          {
            title: "Organización Mundial de la Salud",
            url: "https://www.who.int/es/news-room/fact-sheets/detail/breast-cancer",
          },
          {
            title: "Organización Panamericana de la Salud",
            url: "https://www.paho.org/es/temas/cancer-mama#:~:text=El%20c%C3%A1ncer%20de%20mama%20es%20el%20c%C3%A1ncer%20m%C3%A1s%20com%C3%BAn%20y,Caribe%2C%20y%20casi%2068%2C000%20muertes",
          },
          {
            title:
              "Secretaría de Salud, Gobierno de México. Detecta a tiempo el cáncer de mama.",
            url: "https://www.gob.mx/salud/articulos/deteccion-oportuna?idiom=es",
          },
          {
            title:
              "Instituto Nacional de Salud Pública (INSP) e Instituto Nacional de Cancerología (INCan)",
            url: "https://www.insp.mx/avisos/5090-octubre-cancer-mama-19.html",
          },
        ],
        bibliografia: [
          {
            title: `1.	Norma Oficial Mexicana NOM-041-SSA-2-2011 para la Prevención, Diagnóstico, Tratamiento, Control y Vigilancia Epidemiológica del Cáncer de Mama, México, Secretaría de Salud 2003:6-7`,
            url: "#",
          },
          {
            title: `2.	Consenso Mexicano sobre Diagnóstico y Tratamiento del Cáncer Mamario. Novena Revisión. GAMO 2021`,
            url: "#",
          },
        ],
      },
    };
  },
};
</script>
